import React, { useEffect, useState } from "react";
import { Gavel } from "lucide-react";
import { houseFloor } from "../lib/api";
import { AgentBrain } from "./floor/AgentBrain";

export const FloorBoss = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => houseFloor().then(setD).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  return (
    <div className="bg-[#060b18] border border-[#ffffff14] rounded-2xl p-4 space-y-2" data-testid="floor-boss">
      <div className="flex items-center gap-2 flex-wrap">
        <p className="text-cyan-50 font-bold text-sm flex items-center gap-2"><Gavel className="w-4 h-4 text-amber-300" /> Floor Boss · 7-day scorecard</p>
        <span className="text-[11px] text-cyan-300/50">team weight {d.team_weight}x · limits {d.limits?.per_trade_pct}% / trade · {d.limits?.exposure_pct}% exposure · {d.limits?.daily_loss_pct}% daily loss{d.limits?.daily_cap ? ` · daily cap $${Math.round(d.limits.daily_cap).toLocaleString()} net (${Math.round(d.limits.net_deployed_today || 0).toLocaleString()} at risk) · $${Math.round(d.limits.per_trade_cap_usd || 0).toLocaleString()}/trade max` : ""}</span>
        {d.limits?.reentry && <span className="text-[11px] text-cyan-300/50 w-full" data-testid="floor-boss-reentry">{d.limits.reentry}</span>}
        {d.state?.halted && <span className="ml-auto text-[11px] font-bold text-rose-300 border border-rose-500/50 rounded px-2 py-0.5" data-testid="floor-boss-halted">HALTED · {d.state.halt_reason}</span>}
      </div>
      {(d.agents || []).map((a) => (
        <div key={a.agent} className="flex items-start gap-2 text-xs bg-[#0a1020] rounded-lg px-2.5 py-2" data-testid={`floor-boss-${a.agent}`}>
          <AgentBrain agent={a.agent} size={28} dim={a.benched} />
          <div className="flex-1 min-w-0">
            <p className="text-cyan-50"><b>{a.name}</b> <span className="text-cyan-300/50">score {a.score ?? "—"} · hit {a.hit_rate ?? "—"}% · 7d ${a.pnl_7d}</span></p>
            <p className={`text-[11px] ${a.weight < 1 || a.benched ? "text-rose-300/90" : "text-cyan-200/60"}`}>{a.directive}</p>
          </div>
          <span className={`shrink-0 font-bold ${a.benched ? "text-rose-400" : a.weight > 1 ? "text-emerald-300" : a.weight < 1 ? "text-amber-300" : "text-cyan-200"}`}>{a.benched ? "BENCHED" : `${a.weight}x`}</span>
        </div>
      ))}
    </div>
  );
};
